// extracted by mini-css-extract-plugin
export var leftAlign = "_o-2";
export var popper = "_o-0";
export var subtitle = "_o-1";